import { usePocket } from "@/contexts/PocketContext";
import { useEffect } from "react";
import { navigate } from "vike/client/router";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { user } = usePocket();

    useEffect(() => {
        if (!user) {
            navigate("/auth");
        }
    }, [user]);

    if (!user) {
        return null;
    }

    return <>{children}</>;
} 